import React from 'react';

const Settings = () => {
	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
			<div className="mb-8">
				<h1 className="text-3xl font-bold text-gray-900">Configuración</h1>
				<p className="mt-2 text-sm text-gray-600">
					Configuración del sistema
				</p>
			</div>

			<div className="bg-white shadow rounded-lg p-6">
				<p className="text-gray-600">Esta sección estará disponible próximamente.</p>
			</div>
		</div>
	);
};

export default Settings;

